"use client";
import { useEffect } from "react";
import Link from "next/link";
import { Button } from "@taskflow/ui";
import { AlertTriangle, RotateCw, Home } from "lucide-react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error("[App Error]", error);
  }, [error]);
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-50 p-4">
      <div className="w-full max-w-md rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-rose-50 text-rose-500">
          <AlertTriangle className="h-7 w-7" />
        </div>
        <h1 className="text-xl font-semibold text-slate-900">页面出错了</h1>
        <p className="mt-2 text-sm text-slate-500">抱歉,应用遇到一个意外错误。你可以重试,或者返回首页。</p>
        {error?.digest && (
          <p className="mt-3 rounded-md bg-slate-50 px-3 py-2 font-mono text-[11px] text-slate-400">错误 ID: {error.digest}</p>
        )}
        {error?.message && (
          <details className="mt-3 text-left">
            <summary className="cursor-pointer text-xs text-slate-400">错误详情</summary>
            <pre className="mt-1 max-h-40 overflow-auto rounded-md bg-slate-900 p-3 text-[11px] text-slate-200">{String(error.stack || error.message)}</pre>
          </details>
        )}
        <div className="mt-6 flex justify-center gap-2">
          <Button onClick={reset} iconLeft={<RotateCw className="h-4 w-4" />}>重试</Button>
          <Link href="/workspace/dashboard"><Button variant="ghost" iconLeft={<Home className="h-4 w-4" />}>返回工作台</Button></Link>
        </div>
      </div>
    </div>
  );
}
